import { render, staticRenderFns } from "./Packs.vue?vue&type=template&id=42a1223a"
import script from "./Packs.vue?vue&type=script&lang=js"
export * from "./Packs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports